export const ROW_CLASS_INELIGIBLE = 'credit-reversal-row-ineligible';

export const CREDIT_LIKE_TYPES = [
  'credit',
  'le_points',
  'le_points_airport_transfer',
  'le_points_discounted_insurance',
  'le_points_hotel_upgrade',
  'le_points_lounge_pass',
  'manual',
  'promo',
];

export interface ReversalReason {
  label: string;
  value: string;
}

export const REVERSAL_REASONS: Array<ReversalReason> = [
  { label: 'Within Refund Policy', value: 'within_refund_policy' },
  { label: 'Credit Rebooking Cancelled (Within Policy)', value: 'credit_rebooking_cancelled_within_policy' },
  { label: 'Negative Feedback - TL Approved GWG', value: 'negative_feedback_tl_approved_gwg' },
  { label: 'Downgrade Refund (Within Policy)', value: 'downgrade_refund_within_policy' },
  { label: 'Rebooking & Applying Promo (Within Policy)', value: 'rebooking_applying_promo_within_policy' },
  { label: 'Accidental Credit Conversion (Within Policy)', value: 'accidental_credit_conversion_within_policy' },
  { label: 'Goodwill Gesture (TL Approved)', value: 'goodwill_gesture_tl_approved' },
  { label: 'Failed to Apply Credit (TL Approved)', value: 'failed_to_apply_credit_tl_approved' },
  { label: 'Refund 50%', value: 'refund_50' },
  { label: 'Refund 70%', value: 'refund_70' },
  { label: 'Refund 80%', value: 'refund_80' },
  { label: 'Refund 90%', value: 'refund_90' },
  { label: 'Refund 90% Retain 10% Credit', value: 'refund_90_retain_10_credit' },
  { label: 'Fraud', value: 'fraud' },
  { label: 'Agent Error', value: 'agent_error' },
  { label: 'Tech Error or Mapping Error', value: 'tech_error_or_mapping_error' },
  { label: 'Rejected Booking/Hotel Closure', value: 'rejected_booking_hotel_closure' },
  { label: 'Social Media/ACC/Fair Trading Escalation', value: 'social_media_acc_fair_trading_escalation' },
  { label: 'LuxPlus+ Subscription Refund', value: 'luxplus_subscription_refund' },
  { label: 'Overcharged via Invoice', value: 'overcharged_via_invoice' },
  { label: 'Force Majeure', value: 'force_majeure' },
  { label: 'Flight Refund', value: 'flight_refund' },
  { label: 'Wholesale Rate', value: 'wholesale_rate' },
  { label: 'Tours - Approved by DMC', value: 'tours_approved_by_dmc' },
  { label: 'Other', value: 'other' },
];

// Percentages applied to credit deduction to derive cash reversed.
// refund_90_retain_10_credit is omitted: agent enters the 90% value in Credit Deduction, so Cash Reversed = Credit Deduction.
export const REFUND_PERCENTAGE_MAP: Record<string, number> = {
  refund_50: 0.5,
  refund_70: 0.7,
  refund_80: 0.8,
  refund_90: 0.9,
};
